var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"default"},[_c('img',{staticClass:"logo",attrs:{"alt":"Ho Facil logo","src":require("../assets/images/ho-facil-white.png")}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }